exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reports-main-tabs{position:relative;height:53px}.reports-main-tabs>div:not(.tab-content){background-color:var(--theme-grey-bg)}.reports-main-tabs .nav-tabs{max-width:1140px;margin:auto}.reports-main-tabs .nav-tabs .nav-link{font-size:14px}.reports-main-tabs .nav-tabs:after,.reports-main-tabs .nav-tabs:before{position:absolute;background-color:var(--theme-grey-bg);top:0;left:-99em;width:99em;height:52px;display:block;content:\"\"}.reports-main-tabs .nav-tabs:before{left:-99em}.reports-main-tabs .nav-tabs:after{left:100%}", ""]);

// exports
